<template>
  <vue-ladda :loading="loading" class="bg-transparent" data-spinner-color="#7367F0" data-style="zoom-out">
    <vs-button :class="[{loading: loading} ,'w-full px-3']"
               @click="$emit('click', $event)"
               v-bind="$attrs">
      <slot></slot>
    </vs-button>
  </vue-ladda>
</template>

<script>
  import VueLadda from 'vue-ladda/src/vue-ladda.vue'

  export default {
    name: 'BaseButton',
    components: {
      VueLadda
    },
    props: {
      loading: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      // uniqueID:null
    }),
    methods: {
      // startLoading() {
      //   this.$vs.loading({
      //     container:`#${this.uniqueID}`,
      //     scale:0.1
      //   })
      // },
      // stopLoading() {
      //   this.$vs.loading.close(`#${this.uniqueID}>.con-vs-loading`)
      // },
      // generateId() {
      //   let date = new Date().getTime().toString()
      //   let randomNumber = Math.random().toString()
      //   let id = parseInt(date + randomNumber)
      //   this.uniqueID = String.fromCharCode(id)
      // }
    },
    // created() {
    //   this.generateId()
    // },
    // watch:{
    //   loading(newValue) {
    //     if (newValue) this.startLoading()
    //     else this.stopLoading()
    //   }
    // }
  }
</script>

<style lang="scss">
  .ladda-button {
    @apply rounded-lg p-0;
    max-height: 41px;
  }

  .ladda-button:hover {
    @apply bg-transparent;
  }

  .ladda-label {
    @apply w-full bg-transparent;
  }

  .loading {
    pointer-events: none;
  }
</style>
